import {useEffect, useMemo} from "react";
import {useFormContext, useWatch} from "react-hook-form";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function useDependsOnField(currentFieldName, dependsOnField, choices) {
    const {t} = usePolTranslation();
    const {fieldKey, searchFilter, choices: dependentChoices} = dependsOnField ?? {};

    const dependsOnFieldValue = useWatch({
        name: fieldKey,
        disabled: !fieldKey,
        defaultValue: {},
    });

    const {resetField} = useFormContext();
    useEffect(() => {
        if (!fieldKey) return;

        if (dependsOnFieldValue?.length > 0) return;

        resetField(currentFieldName);
    }, [dependsOnFieldValue, fieldKey, resetField, currentFieldName]);

    const dependsOnFieldChoices =  useMemo(() => {
        return (dependentChoices?.[dependsOnFieldValue] ?? choices ?? []).map(({label, attr = {}, ...choice}) => {
            const {
                'data-is-unselectable': isUnselectable,
            } = attr;

            return {
                ...choice,
                label: t(label),
                ...(isUnselectable && {isDisabled: true}),
            };
        });
    }, [choices, dependentChoices, dependsOnFieldValue, t]);

    const autocompleteAdditionnalSearchFilter = useMemo(() => ({
        filter: searchFilter,
        value: Object.keys(dependsOnFieldValue).length ? dependsOnFieldValue : undefined
    }), [searchFilter, dependsOnFieldValue]);

    return {
        dependsOnFieldChoices,
        autocompleteAdditionnalSearchFilter,
    };
}
